export default __webpack_public_path__ + "static/media/included-m-logo.9413f5d3.png";